import { scheduleActions, SwitchToViewAction } from '../../actions';
import { TimelineView } from '../../../types/timeline';
import { put } from 'redux-saga/effects';
import { selectVisibleTimelinePeriodSaga } from '../../selectors-saga';
import { selectUserSaga } from '../../../../../../../common/saga/selectors';
import LocalCache from '../../../../../../local-storage/local-storage';
import { TimelinePeriod } from '../../../types/TimelinePeriod';
import { TIMELINE_VIEW_KEY } from '../../reducers';

export function* switchToViewWorker(action: SwitchToViewAction) {
  const { currentView } = action.payload;
  const user = yield* selectUserSaga();
  const localCache = new LocalCache('crewSchedulingV2', user);

  localCache.setCached('currentView', currentView);
  localStorage.setItem(TIMELINE_VIEW_KEY, currentView);

  const timePeriod = yield* selectVisibleTimelinePeriodSaga();
  const start = timePeriod.getStart().clone();
  let updatedTimePeriod: TimelinePeriod;

  switch (currentView) {
    case TimelineView.Day:
      updatedTimePeriod = new TimelinePeriod(start, start.clone().add(1, 'day'));
      break;

    case TimelineView.Week:
      updatedTimePeriod = new TimelinePeriod(start, start.clone().add(1, 'week'));
      break;

    case TimelineView.TwoWeeks:
      updatedTimePeriod = new TimelinePeriod(start, start.clone().add(2, 'week'));
      break;

    case TimelineView.ThreeWeeks:
      updatedTimePeriod = new TimelinePeriod(start, start.clone().add(3, 'week'));
      break;

    case TimelineView.Month:
      updatedTimePeriod = new TimelinePeriod(start, start.clone().add(1, 'month'));
      break;

    case TimelineView.ThreeMonths:
      updatedTimePeriod = new TimelinePeriod(start, start.clone().add(3, 'month'));
      break;

    case TimelineView.Year:
      updatedTimePeriod = new TimelinePeriod(start, start.clone().add(1, 'year'));
      break;

    default:
      updatedTimePeriod = timePeriod;
  }

  yield put(scheduleActions.setSwitchedTimelinePeriod(updatedTimePeriod));
}
